import { render, staticRenderFns } from "./purchase-invoice.vue?vue&type=template&id=b6c227ea&scoped=true&"
import script from "./purchase-invoice.vue?vue&type=script&lang=js&"
export * from "./purchase-invoice.vue?vue&type=script&lang=js&"
import style0 from "./purchase-invoice.vue?vue&type=style&index=0&id=b6c227ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c227ea",
  null
  
)

export default component.exports